module.exports = __webpack_public_path__ + "static/img/advantage.3fa3d41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/advantage.png
// module id = JECg
// module chunks = 2